module.exports = __webpack_public_path__ + "img/digital_nomad.1e499d88.svg";